export default __webpack_public_path__ + "static/media/pixzolo-photography-3tL4vtrFqTQ-unsplash.f0bb357d.jpg";